import { getIntegrityMonitorSeverityValues, IntegrityMonitorSeverity } from './types';

export function getSeverityWithBullet(translateFn: Function, severity: number) {
  let bullet;

  const severityLabel = getIntegrityMonitorSeverityValues(translateFn).find(
    element => element.value === severity
  )?.label;

  switch (severity) {
    case IntegrityMonitorSeverity.CRITICAL:
      bullet = 'bullet-darkred';
      break;
    case IntegrityMonitorSeverity.HIGH:
      bullet = 'bullet-danger';
      break;
    case IntegrityMonitorSeverity.MEDIUM:
      bullet = 'bullet-orange';
      break;
    case IntegrityMonitorSeverity.LOW:
    default:
      bullet = 'bullet-yellow';
      break;
  }

  return { severityLabel, bullet };
}
